import { makeRequest } from '../../../lib/api';
import {
  SeoItemListRequestInterface,
  CreateSeoItemRequestInterface,
  UpdateSeoItemRequestInterface,
  CreateSeoPageFaqInterface,
  UpdateSeoPageFaqInterface,
  FindSeoPageRequestInterface,
  CreateSeoBlogInterface,
  UpdateSeoBlogInterface,
} from '../api/seoReferenceApi';

import { ReviewRequestInterface, CreateReviewRequestInterface, UpdateReviewRequestInterface } from '../api/reviewReferenceApi';

import { CreateBannerInterface, UpdateBannerInterface } from '../api/bannerReferenceApi';

const SEO_REFERENCE_PATH = '/v1/users/seo_pages';
const SEO_FAQ_PATH = '/v1/users/seo_page_faqs';
const SEO_BLOG_PATH = '/v1/users/seo_blogs';
const REVIEW_PATH = '/v1/reviews';
const BANNER_PATH = '/v1/banners';

class seoController {
  getSeoPages = (data: SeoItemListRequestInterface) => {
    const param = `serviceId=${ data?.serviceId }${
      data?.parentId ? `&parentId=${ data?.parentId }` : '' }`;
    return makeRequest('get', `${ SEO_REFERENCE_PATH }?${ param }`);
  };

  findSeoPages = (request: FindSeoPageRequestInterface) => {
    return makeRequest('post', `${ SEO_REFERENCE_PATH }/find`, request);
  };

  createSeoPage = (data: CreateSeoItemRequestInterface) => {
    return makeRequest('post', `${ SEO_REFERENCE_PATH }`, data);
  };

  updateSeoPage = (data: UpdateSeoItemRequestInterface) => {
    return makeRequest('put', `${ SEO_REFERENCE_PATH }`, data);
  };

  deleteSeoPage = (id:number) => {
    return makeRequest('delete', `${ SEO_REFERENCE_PATH }/${ id }`);
  };

  reindexSeoPage = (seoPageId:number) => {
    return makeRequest('post', `${ SEO_REFERENCE_PATH }/reindex`, { seoPageId });
  };

  getReviews = (data: ReviewRequestInterface) => {
    const param = `showDeleted=${ data?.showDeleted ? 'true' : 'false' }${
      data?.serviceId ? `&serviceId=${ data?.serviceId }` : '' }`;
    return makeRequest('get', `${ REVIEW_PATH }?${ param }`);
  };

  createReview = (data: CreateReviewRequestInterface) => {
    return makeRequest('post', `${ REVIEW_PATH }`, data);
  };

  updateReview = (data: UpdateReviewRequestInterface) => {
    return makeRequest('put', `${ REVIEW_PATH }/${ data.id }`, data);
  };

  deleteReview = (id:string) => {
    return makeRequest('delete', `${ REVIEW_PATH }/${ id }`);
  };

  restoreReview = (id:string) => {
    return makeRequest('put', `${ REVIEW_PATH }/restore/${ id }`);
  };

  // SEQ FAQ блок
  getSeoPageFaqs = (seoPageId: number) => {
    const param = `seoPageId=${ seoPageId }`;
    return makeRequest('get', `${ SEO_FAQ_PATH }?${ param }`);
  };

  createSeoPageFaq = (data: CreateSeoPageFaqInterface) => {
    return makeRequest('post', `${ SEO_FAQ_PATH }`, data);
  };

  updateSeoPageFaq = (data: UpdateSeoPageFaqInterface) => {
    return makeRequest('put', `${ SEO_FAQ_PATH }/${ data.seoPageFaqId }`, data);
  };

  deleteSeoPageFaq = (seoPageFaqId:string) => {
    return makeRequest('delete', `${ SEO_FAQ_PATH }/${ seoPageFaqId }`);
  };

  // SEQ BLOG блок
  getSeoBlogs = (serviceId : number) => {
    const param = `serviceId=${ serviceId }`;
    return makeRequest('get', `${ SEO_BLOG_PATH }?${ param }`);
  };

  createSeoBlog = (data: CreateSeoBlogInterface) => {
    return makeRequest('post', `${ SEO_BLOG_PATH }`, data);
  };

  updateSeoBlog = (data: UpdateSeoBlogInterface) => {
    return makeRequest('put', `${ SEO_BLOG_PATH }`, data);
  };

  deleteSeoBlog = (id:string) => {
    return makeRequest('delete', `${ SEO_BLOG_PATH }/${ id }`);
  };

  restoreSeoBlog = (id:string) => {
    return makeRequest('post', `${ SEO_BLOG_PATH }/restore/${ id }`);
  };

  // SEQ BLOG блок
  getSeoTree = (data: SeoItemListRequestInterface) => {
    const param = `serviceId=${ data?.serviceId }${
      data?.parentId ? `&parentId=${ data?.parentId }` : '' }`;
    return makeRequest('get', `${ SEO_REFERENCE_PATH }/tree/?${ param }`);
  };

  // Banner блок
  getBannersList = () => {
    return makeRequest('get', `${ BANNER_PATH }`);
  };

  createBanner = (request: CreateBannerInterface) => {
    return makeRequest('POST', `${ BANNER_PATH }`, request);
  };

  updateBanner = (request: UpdateBannerInterface) => {
    return makeRequest('PUT', `${ BANNER_PATH }/${ request.id }`,request );
  };

  deleteBanner = (id: string) => {
    return makeRequest('DELETE', `${ BANNER_PATH }/${ id }` );
  };

  deactivateBanner = (id: string) => {
    return makeRequest('DELETE', `${ BANNER_PATH }/${ id }/activated`);
  };

  activateBanner = (id: string) => {
    return makeRequest('PUT', `${ BANNER_PATH }/${ id }/activated`);
  };
}

export default new seoController();
